// HTTP 请求工具
import axios from "axios";
import { Toast } from 'vant';
import config from "../config/config";
import router from '@/router'

// 设置服务器基础地址
axios.defaults.baseURL = config.baseUrl;

// 设置默认头信息
axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8';

// 请求超时时间
axios.defaults.timeout = 30000;

axios.defaults.withCredentials = true;  //允许跨域

// request 请求拦截器
axios.interceptors.request.use(
    request => {
        return request;
    },
    error => {
        return Promise.reject(error);
    }
);

// response 响应拦截器
axios.interceptors.response.use(
    response => {
        if (response.status === 200) {
            return Promise.resolve(response);
        } else {
            return Promise.reject(response);
        }
    },
    // 服务状态码不是 200 的情况
    error => {
        if (error.response) {
            switch (error.response.status) {
                case 400:
                    Toast.fail("错误码 400 请检查请求体信息");
                    break;
                case 414:
                    Toast.fail("GET 请求参数过大,HTTP 错误码 414 ");
                    break;
                default:
                    Toast.fail(`未知异常，请联系管理员！`);
                    return router.push('/404')
            }
            return Promise.reject(error.response);
        }
    }
);


export default {
    /**
     * get 方法对应 get 请求
     * @param {String} url 请求地址
     * @param {Object} params 携带参数
     * @returns {Promise}
     */
    get(url, params) {
        return new Promise((resolve, reject) => {
            axios.get(url, {
                params: params,
            })
                .then(res => {
                    resolve(res.data);
                })
                .catch(err => {
                    reject(err.data);
                });
        });
    },
    /**
     * post 方法对应 post 请求
     * @param {String} url 请求地址
     * @param {Object} params 携带参数
     * @returns {Promise}
     */
    post(url, params) {
        return new Promise((resolve, reject) => {
            axios.post(url, JSON.stringify(params), { headers: { 'Content-Type': 'application/json;charset=UTF-8' } })
                .then(res => {
                    resolve(res.data);
                })
                .catch(err => {
                    reject(err.data);
                });
        });
    },
    put(url, params) {
        return new Promise((resolve, reject) => {
            axios.put(url, JSON.stringify(params), { headers: { 'Content-Type': 'application/json;charset=UTF-8' } })
                .then(res => {
                    resolve(res.data);
                })
                .catch(err => {
                    reject(err.data);
                });
        });
    },
    delete(url, params) {
        return new Promise((resolve, reject) => {
            axios.delete(url, JSON.stringify(params), { headers: { 'Content-Type': 'application/json;charset=UTF-8' } })
                .then(res => {
                    resolve(res.data);
                })
                .catch(err => {
                    reject(err.data);
                });
        });
    },
    download(url, params) {
        return new Promise((resolve, reject) => {
            axios.post(url, JSON.stringify(params), { headers: { 'Content-Type': 'blob' } })
                .then(res => {
                    resolve(res.data);
                })
                .catch(err => {
                    reject(err.data);
                });
        });
    }
};
